



























import Vue from 'vue';

export default Vue.extend({
  props: {
    entities: { type: [Number, Array], default: undefined },
    type: { type: String, default: 'warning' },
  },
  computed: {
    title(): string {
      if (this.numberOfEntities > 1) {
        return this.$t('core.app.deleteMultipleConfirmationTitle');
      }
      return this.$t('core.app.deleteSingularConfirmationTitle');
    },
    message(): string {
      if (this.numberOfEntities > 1) {
        return this.$t('core.app.deleteMultipleConfirmationMessage', this.numberOfEntities);
      }
      return this.$t('core.app.deleteSingularConfirmationMessage');
    },
    numberOfEntities(): number {
      if (this._.isArray(this.entities)) {
        return this.entities.length;
      }
      return this.entities ?? 1;
    },
  },
  methods: {
    close(value: boolean) {
      this.$emit('input', value);
      this.$el.remove();
      this.$destroy();
    },
  },
});
